import { executeIncomeExport, exportRegSetl, getOrderPayDocNum, queryOrderPayDoc, exportOrderPayDoc, queryOrderDetailDoc, 
  geOrderDetailNum, exportOrderDetail, queryArrearsOrder, queryRegSetl, getRegSetlNum, getChargeReport, exportChargeReport, 
  getCashier, cashierExport, getExecuteIncome, getExecuteIncomeCount, getReportToken, prescribePage, exportPrescribe,getPushList,
  rePush,exportFormulaLog,getFormulaLog,getSalesPerformanceReportPage,salesExport,getCouponData,couponExport } from '@/api/statement'

class statementDTO {
    /**
      * 查询单据统计
      */
    static getOrderPayDocNum(params) {
        return new Promise((resolve, reject) => {
            getOrderPayDocNum(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询单据
      */
    static queryOrderPayDoc(params) {
        return new Promise((resolve, reject) => {
            queryOrderPayDoc(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 单据导出
      */
    static exportOrderPayDoc(params, customConfig) {
        return new Promise((resolve, reject) => {
            exportOrderPayDoc(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询明细
      */
    static queryOrderDetailDoc(params) {
        return new Promise((resolve, reject) => {
            queryOrderDetailDoc(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询明细统计
      */
    static geOrderDetailNum(params) {
        return new Promise((resolve, reject) => {
            geOrderDetailNum(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 明细导出
      */
    static exportOrderDetail(params, customConfig) {
        return new Promise((resolve, reject) => {
            exportOrderDetail(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询欠费订单
      */
    static queryArrearsOrder(params) {
        return new Promise((resolve, reject) => {
            queryArrearsOrder(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询挂号结算
      */
    static queryRegSetl(params) {
        return new Promise((resolve, reject) => {
            queryRegSetl(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询挂号结算统计
      */
    static getRegSetlNum(params) {
        return new Promise((resolve, reject) => {
            getRegSetlNum(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 查询收费日报
      */
    static getChargeReport(params) {
        return new Promise((resolve, reject) => {
            getChargeReport(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
    * 导出收费日报
    */
    static exportChargeReport(params, customConfig) {
        return new Promise((resolve, reject) => {
            exportChargeReport(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 查询收费日报
     */
    static getCashier(params) {
        return new Promise((resolve, reject) => {
            getCashier(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 导出收费日报
     */
    static cashierExport(params, customConfig) {
        return new Promise((resolve, reject) => {
            cashierExport(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 查询收费日报
     */
    static getExecuteIncome(params) {
        return new Promise((resolve, reject) => {
            getExecuteIncome(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
     * 查询执行业绩统计
     */
    static getExecuteIncomeCount(params) {
        return new Promise((resolve, reject) => {
            getExecuteIncomeCount(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
     /**
     * 登陆分析系统
     */
    static getReportTokenDTO(url){
        return new Promise((resolve, reject) => {
            console.log(JSON.parse(sessionStorage.getItem('user')).userCode);
            let obj={
                user_name:JSON.parse(sessionStorage.getItem('user')).userCode
            }
            getReportToken(obj).then(res => {
                if (res.errorCode === "0000") {
                    url += `&${res.data.paramName}=${encodeURIComponent(
                        res.data.paramValue
                    )}`;
                    resolve({code: 200,url})
                }else{
                    resolve({ code: 500 })
                }
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 导出挂号结算
      */
    static exportRegSetl(params, customConfig) {
        return new Promise((resolve, reject) => {
            exportRegSetl(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 导出执行业绩
      */
    static executeIncomeExport(params, customConfig) {
        return new Promise((resolve, reject) => {
            executeIncomeExport(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 导出开方统计
      */
    static exportPrescribe(params, customConfig) {
        return new Promise((resolve, reject) => {
            exportPrescribe(params, customConfig).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    /**
      * 开方统计
      */
    static prescribePage(params) {
        return new Promise((resolve, reject) => {
            prescribePage(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    //查询推送失败订单列表
    static getPushList(params) {
        return new Promise((resolve, reject) => {
          getPushList(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    //重推
    static rePush(params) {
        return new Promise((resolve, reject) => {
          rePush(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
    }
    //导出配方日志
    static exportFormulaLog(params, customConfig) {
      return new Promise((resolve, reject) => {
        exportFormulaLog(params, customConfig).then(res => {
              resolve(res)
          }).catch(() => {
              resolve({ code: 500 })
          })
      })
    }
      //查询配方日志
      static getFormulaLog(params) {
        return new Promise((resolve, reject) => {
          getFormulaLog(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
      }
      //查询接待人业绩
      static getSalesPerformanceReportPage(params) {
        return new Promise((resolve, reject) => {
          getSalesPerformanceReportPage(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
      }
      //导出配方日志
    static salesExport(params, customConfig) {
      return new Promise((resolve, reject) => {
        salesExport(params, customConfig).then(res => {
              resolve(res)
          }).catch(() => {
              resolve({ code: 500 })
          })
      })
    }
      //查询优惠券报表
      static getCouponData(params) {
        return new Promise((resolve, reject) => {
          getCouponData(params).then(res => {
                resolve(res)
            }).catch(() => {
                resolve({ code: 500 })
            })
        })
      }
      //导出优惠券报表
    static couponExport(params, customConfig) {
      return new Promise((resolve, reject) => {
        couponExport(params, customConfig).then(res => {
              resolve(res)
          }).catch(() => {
              resolve({ code: 500 })
          })
      })
    }
}

export { statementDTO }